import type { ComponentType } from "react";

import {
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
  Youtube,
  AtSign,
  MapPin,
  Camera,
} from "lucide-react";

import tiktokIcon from "@/assets/social/tiktok.svg";
import substackIcon from "@/assets/social/substack-small.webp";
import blueskyIcon from "@/assets/social/bluesky.webp";
import redditIcon from "@/assets/social/reddit.png";
import discordIcon from "@/assets/social/discord.svg";
import pinterestIcon from "@/assets/social/pinterest.png";

export type SocialIcon = string | ComponentType<{ className?: string }> | null;

export const getSocialIcon = (platform: string): SocialIcon => {
  const customIcons = {
    tiktok: tiktokIcon,
    substack: substackIcon,
    bluesky: blueskyIcon,
    reddit: redditIcon,
    discord: discordIcon,
    pinterest: pinterestIcon,
  };

  const lucideIcons = {
    facebook: Facebook,
    twitter: Twitter,
    instagram: Instagram,
    linkedin: Linkedin,
    youtube: Youtube,
    threads: AtSign,
    google_business: MapPin,
    snapchat: Camera,
  };

  if (customIcons[platform as keyof typeof customIcons]) {
    return customIcons[platform as keyof typeof customIcons];
  }

  return lucideIcons[platform as keyof typeof lucideIcons] || null;
};
